import { html } from 'lit';
const SortUp =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M14 6.75h6a.75.75 0 1 0 0-1.5h-6a.75.75 0 0 0 0 1.5m1 4a.75.75 0 0 0 0 1.5h5a.75.75 0 1 0 0-1.5zm5 7h-4a.75.75 0 0 1 0-1.5h4a.75.75 0 1 1 0 1.5M9.05 18a.75.75 0 0 1-1.5 0V7.81l-2.72 2.72a.75.75 0 1 1-1.06-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L9.05 7.81z" clip-rule="evenodd"/>
  </svg>
`;
export default SortUp;
